<template>
    <div> 
		<div  v-if="tradingAccountList.totalRecords > 0">
			<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModulePass)">
				<app-twofa  :call_from="request_page"></app-twofa>
			</div>
			<div v-else>
				<div class="mainTitle text-center mt-4 mb-3"> 
					<h2 class="mb-3">{{$t('cp_changePassword')}}</h2>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div> 
				<!--loader - message--->
				
				<!-------------------->
				<div class="CustomBlockWidth "> 
					<div class=" row justify-content-center">
						<div class="middleBox">
							<div class="whiteBG p-4">
								<!---------------------request form----------------------->
								<div class="partcipate-fund" v-if="transaction_id == '' && !congModulePass"> 
									<div class="clearfix"></div>
									<div class="form-group field-wrapper">
										<account-id></account-id>
									</div> 
									<div class="clearfix"></div>
									<div class="form-group field-wrapper">
										<input placeholder=" " type="password" v-model="password"  v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{6,24}$/}" name="password" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('password') }" ref="passwordInput" />
										<label for="password" class="float-label">{{$t('cp_newPassword')}}</label>
										<p class="error" v-for="error in errors.collect('password')">
											<span v-show="error == 'The password field is required.'">{{$t('reg_passwordFieldReq')}}</span>
											<span v-show="error == 'The password field format is invalid.'">{{$t('reg_passCharVal')}}</span>
										</p>
									</div>
									<div class="form-group field-wrapper">
										<input placeholder=" " type="password" v-model="con_password" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{6,24}$/, confirmed:password}" name="con_password" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('con_password') }" ref="con_passwordInput" />
										<label for="password" class="float-label">{{$t('reg_conPassword')}}</label>
										<p class="error" v-for="error in errors.collect('con_password')">
											<span v-show="error == 'The con_password field is required.'">{{$t('reg_passwordFieldReq')}}</span>
											<span v-show="error == 'The con_password field format is invalid.'">{{$t('reg_passCharVal')}}</span>
											<span v-show="error == 'The con_password confirmation does not match.'">{{$t('reg_newConfFieldSame')}}</span>
										</p>
									</div>							
									<div class="form-group text-center field-wrapper">
										<button class="prism_btn btn_sm" v-on:click.prevent="submitChangePasswordRequestOtp()">{{$t('cp_newPassword')}} </button>
									</div> 
									<div class="signupbtn mt-2 text-center" v-if="come_from_manage_page">
										<router-link :to="'/account'" class="underline">{{$t('lev_backManageAccount')}}</router-link>
									</div>
									<div class="clearfix"></div>
								</div>
								<!------------------------------------------------------------>
								<div class="partcipate-fund" v-if="transaction_id != '' && !congModulePass">
									<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)"> 
										<p class="mb-3 text-center">{{$t('rb_googleAuth1')}} <strong>{{$t('rb_googleAuth2')}}</strong> {{$t('rb_googleAuth3')}}. </p>
										<div class="form-group field-wrapper">
											<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedPasswordOtp && errors.has('otp') }" ref="otpInput">
											<p v-for="error in errors.collect('otp')">{{ error }}</p>
										</div> 
										<div class="form-group text-center field-wrapper">
											<button class="prism_btn btn_sm " v-on:click.prevent="submitChangePasswordCheckOtp()">{{$t('rb_validate')}} </button>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
											<div class="desc text-center">
												<p>{{$t('rb_googleAuth4')}} <a v-on:click.prevent="resendLink()" href="#"><strong>{{$t('rb_googleAuth5')}}</strong></a></p>
											</div>
										</div>
										<div class="clearfix"></div>
									</div>

									<div class="middleBox1"  v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
										<div class="congratulations">
											<div class="logo_congrats">
												<img src="../../../../static/fxView/images/change_password.svg" alt="Icon">
											</div>
											<div class="subtitle">
												<p class="mb-3">{{$t('verf_dear')}} <strong class="green">{{get_user.username}}</strong>
													{{$t('rb_googleAuth6')}} <strong>{{get_user.email}} . </strong> {{$t('levPwd_passMsz1')}}
												</p>
												<a v-on:click.prevent="resendLink()" href="#" class="mb-3"><strong>{{$t('rb_googleAuth7')}}</strong></a>
											</div>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
											<div class="ico mr-3">
												<img src="../../../../static/fxView/images/google_auth.png" alt="2fa">
											</div>
											<div class="desc w-75">
												<h5 class="mb-2"><strong>{{$t('rb_googleAuth8')}}</strong></h5>
												<p>{{$t('rb_googleAuth9')}} <a v-on:click.prevent="authComponent = true" href="#"><strong>{{$t('rb_googleAuth10')}}</strong></a></p>
											</div>
										</div>
									</div>
								</div>

								<!---------------------congo-message-------------->
								<div class="stepForm" v-if="congModulePass">
									<div class="congratulations">
										<div class="logo_congrats">
											<img src="../../../../static/fxView/images/check.svg" alt="Icon">
										</div>
										<div class="subtitle">
											<h3>{{$t('rb_congo')}} <span class="green">{{get_user.username}}</span></h3>
											<p>{{$t('lePwd_passMsz2')}}</p>
											<ul class="includeWdth">
												<li><strong>{{$t('lev_tradingId')}}</strong> {{account_id}}</li>
												<li><strong>{{$t('lePwd_oldPassword')}}</strong>-</li>
												<li><strong>{{$t('cp_newPassword')}}</strong>{{password}}</li>
											</ul>
										</div>
										<div class="signupbtn full-width submitButton w-100 mt-2 text-center">
											<router-link :to="'/account'" class="prism_btn btn_sm" v-if="$route.name == 'fxView.changeLeverage'">{{$t('lev_goBackMangeAccv')}}</router-link>
											<button class="prism_btn btn_sm" v-on:click.prevent="back()" v-else>{{$t('lev_goBackMangeAccv')}}</button>
										</div>
									</div>  
								</div>
							</div>
						</div>				
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="tradingAccountList.totalRecords == 0">
            <div class="mainTitle  text-center my-3">
                <h3>{{$t('lev_noDemoLiveTradingAccFound')}}</h3>
            </div>
            <no-trading-account :demo_live_both="'b'" :totalRecords = "tradingAccountList.totalRecords"></no-trading-account>
        </div>
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('dep_acc_fund_plzWaitWhileProc')}}</h4>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import twoFa from '../users/2FA'
    export default {
        name: 'Change-Password',
        mixins: [fxViewMixins],
        data() {
            return {
				pageName : 'Change-Password',
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
                come_from_manage_page : false,
				//-----select account----
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'', 
				//------------------------
                password : '',
                con_password : '',
                submitted : false,
				mszValidationAcco : false,

                otp : '',
                submittedPasswordOtp : false,
                transaction_id : '',
                congModulePass : false,
                authComponent : false,
                request_page : 'password',
				mszValidation : ''
            }
        },
        components: {
            appTwofa: twoFa
        },
        methods:{
        	back(){
        		this.reset()
        		this.otp = ''
        		this.transaction_id = ''
        		this.congModulePass = false
        		this.authComponent = false
        	},
            resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runResendEmailLinkAccount(input_json)
            },
            //==================password===================
            submitChangePasswordRequestOtp(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
						let input_json={
							'globalParams' :{
								'account_id' : _that.account_id ,
								'act_account_id' : _that.act_account_id,
								'password' : _that.password,
								'operation' : 'CHANGE PASSWORD'
							},
							'localParams' :{ "parameter" : _that }
						}
						_that._runAccountPasswordRequestOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            submitChangePasswordCheckOtp(){
                const _that = this
                this.submittedPasswordOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runAccountPasswordCheckOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            reset(){
				this.act_account_id = ''
                this.account_id = ''
                this.password = ''
				this.demo_live = ''
				this.platform = ''
                this.submitted = false
            }
        },
        created(){
            if(this.$route.params.account_id){
                this.come_from_manage_page = true
                this.account_id = this.$route.params.account_id
				this.act_account_id = this.$route.params.act_account_id
				this.demo_live = this.$route.params.demo_live
				this.platform = this.$route.params.platform
            }
			// this._runGetTradingAccountList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
        },
		mounted() { 
			const _that = this
            $(document).on("click", function(event){
				if(!$(event.target).closest('.SelectAcntList').length){
                    _that.selectAccount = false
                }
            });
			
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/change_password1.vue